import { Route, Routes } from 'react-router-dom'

// import { OnlyGuest, OnlyMember } from '.'
import * as pages from '.'

const Router = () => {
  return (
    <Routes>
      <Route element={<pages.Main />} path="/" />
      {['/apply/:manager_code'].map(path => (
        <Route key={path} path={path} element={<pages.Application />} />
      ))}
      {['/sponge-f/apply/:manager_code'].map(path => (
        <Route key={path} path={path} element={<pages.ApplicationSpongeF />} />
      ))}
      {['/sponge-cf/confirm/:manager_code'].map(path => (
        <Route key={path} path={path} element={<pages.ConfirmSpongeCF />} />
      ))}
      {['/sponge-cf/apply/:manager_code'].map(path => (
        <Route key={path} path={path} element={<pages.ApplicationSpongeCF />} />
      ))}
      <Route element={<pages.Main />} path="/" />
      {['/apply/:manager_code/shop/:shop_idx'].map(path => (
        <Route key={path} path={path} element={<pages.ApplicationNormal2Premium />} />
      ))}
      <Route element={<pages.Account />} path="/apply/account/:shop_code" />
      <Route element={<pages.Interest />} path="/review/interest/:review_token" />
      <Route element={<pages.AppFood />} path="/app/shop/:shop_code" />
      <Route element={<pages.PromotionPage />} path="/event" />
      <Route element={<pages.NotFound />} path="*" />
    </Routes>
  )
}

export { Router }
